<template>
	<div>
		<div v-for="(item,idx) in DataList" @click="ziXun(item)">
			<div class="dataitem">
				<div class="zjhead">
					<img :src="item.zj_headimg" />
				</div>
				<div class="zjinfo">
					<div class="zjname">
						{{item.zj_name}} {{item.title_name}}
					</div>
					<div class="zj_zhicheng">
						{{item.zj_hospital}}
						<div style="float: right;">
							<span v-if="item.replied==0||item.reask==1" style="color: #FE0346;">未回复</span><span style="color: #0C85E1;" v-else>已回答</span>
						</div>

					</div>
					<div class="zj_desc" v-html="item.msgcontent">
						
					</div>
				</div>
			</div>
			<div style="text-align: right; padding: 5px 15px; font-size: 12px;">{{getCdate(item.cdate)}}</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
				keyword: "",
				DataList: []

			}
		},

		mounted() {

			this.getList();
		},
		methods: {
			getList() {
				$("#loading").show()
				this.$store.dispatch("GET", {
					url: "/api/zixun/?action=zxhisroty"
				}).then(result => {
for(let item of result.data.rows){
						item.msgcontent = (item.msgcontent)
					}
					this.DataList = result.data.rows;
					$("#loading").hide()
					this.$nextTick(function(){
						$(".zj_desc").each(function(idx,ele){
							$(ele).html($(ele).text())
						})
					})
				})
			},
			searchData() {
				sessionStorage.setItem("zxkeyword", this.keyword)
				this.getList()
			},
			ziXun(item) {
				this.$router.push("/zxresult/" + item.id)
			}
		}
	}
</script>

<style scoped="scoped">
	.dataitem {
		padding: 15px 15px 0 15px;
		position: relative;
	}

	.zjhead {
		width: 100px;
		height: 100px;
		float: left;
	}

	.zjhead img {
		width: 100%;
		height: 100%;
		border-radius: 6px;
	}

	.zjinfo {
		margin-left: 110px;
		min-height: 100px;
	}

	.zjname {
		height: 20px;
		line-height: 20px;
		overflow: hidden;
		color: #000;
		font-weight: bold;
	}

	.zj_zhicheng {
		color: #474747;
		font-size: 13px;
		padding-top: 6px;
	}

	.zj_desc {
		padding-top: 6px;
		font-size: 12px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;



	}

	.btnzj {
		width: 60px;
		height: 24px;
		line-height: 24px;
		text-align: center;
		background: #0C85E1;
		color: #FFFFFF;
		position: absolute;
		right: 10px;
		top: 38px;
		border-radius: 4px;
		font-size: 12px;
	}

	.searchbar {
		position: fixed;
		height: 50px;
		top: 0;
		width: 100%;
		z-index: 1;
		background: rgba(255, 255, 255, 0.8);
	}

	.searcbox {
		width: 70%;
		height: 100%;
		border: 0;
		padding: 0;
		margin: 0;
		padding-left: 30px;
		background-image: url(//gmbaby.oss-cn-shanghai.aliyuncs.com/gmbaby/8586240157273748023.png);
		background-size: auto 80%;
		background-repeat: no-repeat;
		background-position: left center;
	}

	.searchbtn {
		height: 30px;
		width: 50px;
		float: right;
		background: #0C85E1;
		color: #FFFFFF;
		text-align: center;
		line-height: 30px;
		border-radius: 4px;
	}
</style>
